import logoImg from '../assets/partydeco-logo.png';

function AppHeader() {
    return (
        <header className="product-header">
            <img src={logoImg} className="object-scale-down w-full mt-12" alt="logo" />
        </header>
    );
}
export default AppHeader;